export default {
    title: "",
    subtitle: "",
    path: "refund_received_transaction",
    paragraph: "For an already processed account, you will pay using the cash-out account, as it already got in your internal cash-in account. It will work like a payout.",
    request:  {
      method: "GET", 
      endpoint: "/transactions/:id/refund_received_transaction",
      responses: {
        "data": {
          "bank_transaction": {
            "currency": "USD",
            "estimated_value": "184.73",
            "estimated_value_until_exchange": true,
            "exchange_approved": false,
            "exchange_currency": "BRL",
            "exchange_id": null,
            "exchange_rate": null,
            "exchange_rate_spot": null,
            "exchanged_value": "1000",
            "id": "40ec25fa-59fd-4fac-a012-2091b16d34a3",
            "inserted_at": "2023-11-10T13:22:31.100380",
            "iof_value": null,
            "movement_date": "2023-11-10",
            "source_account": null,
            "source_bank": null,
            "source_branch": null,
            "source_description": "CREDITO POR TED ANTECIPADO",
            "source_document_number": "67645727390",
            "source_document_type": "cpf",
            "source_id": "6a9045ac-1f24-4cd9-bc88-2547d52b88d3",
            "source_name": "Person Name",
            "source_type": "TED-PRE",
            "spei_concepto_de_pago": null,
            "spei_reference": null,
            "value": "184.73",
            "wire_id": null
          },
          "cleared": true,
          "currency": "USD",
          "estimated_value_until_exchange": true,
          "exchange_currency": "BRL",
          "exchange_under_request": false,
          "exchanged_value": "1000",
          "for_exchange": true,
          "from_bank_account": {
            "aba": "000000016",
            "account_number": "000016",
            "account_type": "conta-corrente",
            "bank": {
              "code": "123",
              "id": "ae7f2a66-6c09-4356-bc47-a94c17852f46",
              "name": "Bank 123",
              "swift": null
            },
            "branch_country": "Brasil",
            "branch_number": "0016",
            "currency": "USD",
            "iban": "000000016",
            "id": "c44fe69d-3316-43f3-be8e-89975c35be3a",
            "intermediary_bank_account_id": null,
            "internal": true,
            "nickname": null,
            "owner_document_number": "12345678901",
            "owner_name": "Account owner name",
            "pix_info": {"key": "partnername@facilitapay.com", "type": "EMAIL"},
            "routing_number": null
          },
          "from_credit_card": null,
          "id": "6a9045ac-1f24-4cd9-bc88-2547d52b88d3",
          "inserted_at": "2023-11-10T13:22:31.078388",
          "meta": null,
          "source_document_number": "1111111111",
          "source_document_type": "cpf",
          "source_name": "Person Name",
          "status": "identified",
          "subject": {
            "address_city": "São Paulo",
            "address_complement": "Apt 20",
            "address_country": "Brasil",
            "address_neighborhood": "Bairro",
            "address_number": "999",
            "address_postal_code": "0000000",
            "address_state": "SP",
            "address_street": "Rua X",
            "birth_date": "1989-04-01",
            "clearance_level": 1,
            "document_number": "1111111111",
            "document_type": "cpf",
            "email": "person@email.com",
            "fiscal_country": "Brasil",
            "id": "b9235120-bebd-49ba-beb5-f173a7c16e97",
            "inserted_at": "2023-11-10T13:22:30.874817",
            "net_monthly_average_income": "4000.00",
            "phone_number": "+55 (18) 99854-9234",
            "references": [],
            "required_clearance_level": 1,
            "rfc_pf": null,
            "social_name": "Person Name",
            "status": "approved",
            "updated_at": "2023-11-10T13:22:31.026744"
          },
          "subject_id": "b9235120-bebd-49ba-beb5-f173a7c16e97",
          "subject_is_receiver": true,
          "to_bank_account": {
            "aba": null,
            "account_number": "28319-0",
            "account_type": "conta-corrente",
            "bank": {
              "code": "001",
              "id": "f9ccd2c3-a83c-4548-b9c9-0eb00e1fd436",
              "name": "Banco do Brasil S.A.",
              "swift": null
            },
            "branch_country": null,
            "branch_number": "2718",
            "currency": "BRL",
            "iban": null,
            "id": "18421642-ce13-4d7e-9cb8-64cf2beb362d",
            "intermediary_bank_account": null,
            "nickname": null,
            "owner_company": {
              "document_number": "67645727390",
              "document_type": "cpf",
              "id": "b9235120-bebd-49ba-beb5-f173a7c16e97",
              "social_name": "Person Name"
            },
            "owner_document_number": "67645727390",
            "owner_name": "Person Name",
            "pix_info": null,
            "routing_number": null
          },
          "value": "184.73"
        }
      }
    }
  }


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/RefundScheduledBankTransaction.js